import { areaSeriesMark } from '../area/constant';
import type { SeriesMarkMap } from '../interface/common';

export const rangeAreaSeriesMark: SeriesMarkMap = {
  ...areaSeriesMark
};
